import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { getLinkByorganizationIdAndServiceAPI } from 'src/store/organization/restCallOrganization';
import tableStyle from '../Tables/Tables.module.scss';
import { isPortfolioAssociate, readRememberedRole } from 'src/auth/portfolioAssociate';

const RESULTADOS_GEI = 'RESULTADOS_GEI';

interface ResultsPowerBiButtonProps {
    organizationId?: string | null;
}

/**
 * T10 — Results-module Power BI entry.
 * Reuses Events/Portafolio pattern: probe link-service, open internal /powerbi viewer.
 * Silent when missing/unauthorized — does not toast or break Results.
 */
const ResultsPowerBiButton: React.FC<ResultsPowerBiButtonProps> = ({ organizationId }) => {
    const associate = isPortfolioAssociate(readRememberedRole());
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        if (associate) {
            return;
        }
        let cancelled = false;

        const probe = async () => {
            if (!organizationId) {
                setShowButton(false);
                return;
            }
            try {
                const response = await getLinkByorganizationIdAndServiceAPI(organizationId, RESULTADOS_GEI);
                const link = response?.Response;
                const hasUrl = response?.StatusCode === 200 && link && typeof link.url === 'string' && link.url.length > 0;
                if (!cancelled) {
                    setShowButton(!!hasUrl);
                }
            } catch {
                if (!cancelled) {
                    setShowButton(false);
                }
            }
        };

        probe();
        return () => {
            cancelled = true;
        };
    }, [organizationId, associate]);

    if (associate || !showButton || !organizationId) {
        return null;
    }

    const openPowerBi = () => {
        const url = `${process.env.REACT_APP_BASE_URL as string}/powerbi/${organizationId}/${RESULTADOS_GEI}`;
        window.open(url, '_blank');
    };

    return (
        <Button
            type="primary"
            className={tableStyle['powerbi-button']}
            style={{ marginLeft: 8, height: 32, marginTop: 0 }}
            onClick={openPowerBi}
        >
            Visualizar Resultados en Power BI
        </Button>
    );
};

export default ResultsPowerBiButton;
